import { Button } from '@/components/ui/button';
import { eventCatalog } from './catalog.generated';
export interface EventPolicy {
  cosign_permission?: string | null;
  event_type: string;
  require_cosign: boolean;
  write_permission?: string | null;
}
export function EventPolicyEditor({
  value,
  onChange,
  disabled,
}: {
  value: EventPolicy[];
  onChange: (policies: EventPolicy[]) => void;
  disabled?: boolean;
}) {
  const types = Object.keys(eventCatalog).filter(
    (t) =>
      t.startsWith('VITALS.') ||
      t.startsWith('PRENATAL.') ||
      ['CHECKLIST.ITEM', 'CONSENT.DECISION', 'EXAM.SECTION', 'LAB.URINE_DIP', 'NOTE.PROGRESS'].includes(t),
  );
  const update = (index: number, patch: Partial<EventPolicy>) =>
    onChange(value.map((p, i) => (i === index ? { ...p, ...patch } : p)));
  return (
    <fieldset disabled={disabled} className="space-y-3">
      <legend className="font-semibold">Event-specific authorization and supervision</legend>
      <p>
        These requirements add to clinical permissions. Permission names must already exist in this practice’s
        authorization catalog. No access is granted by publishing a policy.
      </p>
      {value.map((policy, i) => (
        <div key={i} className="flex flex-wrap gap-3 border p-3">
          <label>
            Event{' '}
            <select
              value={policy.event_type}
              className="min-h-11 border"
              onChange={(e) => update(i, { event_type: e.target.value })}>
              {types.map((t) => (
                <option key={t}>{t}</option>
              ))}
            </select>
          </label>
          <label>
            Additional write permission{' '}
            <input
              className="min-h-11 border"
              value={policy.write_permission || ''}
              onChange={(e) => update(i, { write_permission: e.target.value || null })}
            />
          </label>
          <label>
            Additional cosign permission{' '}
            <input
              className="min-h-11 border"
              value={policy.cosign_permission || ''}
              onChange={(e) => update(i, { cosign_permission: e.target.value || null })}
            />
          </label>
          <label>
            <input
              type="checkbox"
              checked={policy.require_cosign}
              onChange={(e) => update(i, { require_cosign: e.target.checked })}
            />
            Always require a distinct cosigner
          </label>
          <Button type="button" variant="outline" onClick={() => onChange(value.filter((_, index) => index !== i))}>
            Remove policy
          </Button>
        </div>
      ))}
      <Button
        type="button"
        variant="outline"
        onClick={() =>
          onChange([
            ...value,
            {
              require_cosign: true,
              event_type: types.find((t) => !value.some((p) => p.event_type === t)) || 'VITALS.BP',
            },
          ])
        }>
        Add event policy
      </Button>
    </fieldset>
  );
}
